/**
 * StringUtil.ts
 */
export class StringUtil {
    static toCSV(array) {
        let csv = "";
        for (let i = 0; i < array.length; i++) {
            csv += array[i] + ",";
        }
        return csv.substring(0, csv.length - 1);
    }
    static replaceAll(original, key, value) {
        return original.split(key).join(value);
    }
    static firstCharUp(str) {
        return str.charAt(0).toUpperCase() + str.substr(1);
    }
    static squash(value) {
        return value.replace(/\s+/g, "");
    }
    static pad(s, i, character = "0") {
        while (s.length < i) {
            s = s + character;
        }
        return s;
    }
    static isTrue(value) {
        return value && value.toLowerCase() == "true";
    }
    static isFalse(value) {
        return value && value.toLowerCase() == "false";
    }
}
//# sourceMappingURL=StringUtil.js.map